import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from 'src/environments/environment';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY, ReCaptchaV3Service } from 'ng-recaptcha';
import { AvlaToastModule } from 'avla-components';
import { NavigationService } from './quote/services/navigation.service';
import { AppComponent } from './app.component';
import { appReducers } from './app.reducer';
import { SecurityInterceptor } from './common/interceptor/security.interceptor';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    StoreModule.forRoot(appReducers),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    }),
    AvlaToastModule,
    RecaptchaV3Module,
  ],
  providers: [
    {
      provide: 'googleTagManagerId',
      useValue: environment.TAG_MANAGER_CONTAINER_ID,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SecurityInterceptor,
      multi: true,
    },
    ReCaptchaV3Service,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.CAPTCHA_SITE_KEY_V3,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private navigationService: NavigationService) {}
}
